import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, Box, Typography, IconButton, DialogContent, DialogActions } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate, useDataProvider } from 'react-admin';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Close } from '@material-ui/icons';
import Table from '../common/table';
import { PrimaryButton as Button, WhiteButton } from '../common/button';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(() => ({
    btnClose: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: '0.4px',
    },
    borderClose: {
        borderRadius: "10px",
        border: "solid 2px #e5f1f8",
        backgroundColor: " #ffffff",
    },
    Tittle: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
    },
    dialogActions: {
        marginRight: 28
    }
}));

const config = {
    headers: [
        { field: 'name', label: 'Name', width: 3, bold: true },
        { field: 'description', label: 'Description', width: 4 },
        { field: 'owner', label: 'Owner', width: 1 },
    ],
}

export default function ListMoviesDialog({ open, onClose }) {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [moviesTableConfig, setMoviesConfig] = useState({
        bodies: [],
        sortable: { field: 'name', order: 'DESC' },
    });

    const { nodeSelected } = useSelector(state => state.tree);
    const { nodeApplication } = nodeSelected.applicationData;
    const { mediaGrid } = nodeApplication;
    const { files } = mediaGrid;

    const onEnter = () => {
        getListMovies();
    }

    const getListMovies = () => {
        setLoading(true);
        dataProvider('GET_LIST', 'medias', {
            filter: { type: 'Movie' },
            pagination: { page: 1, perPage: 100 },
            sort: {
                field: 'name',
                order: 'DESC'
            },
        }).then(({ data }) => {
            data.forEach(item => {
                if (files.find(file => file.id === item.id)) {
                    item.checked = true;
                } else {
                    item.checked = false;
                }
            });

            setMoviesConfig({
                ...moviesTableConfig,
                bodies: data
            });
            console.log('@@@ GET LIST MOVIES:', data);
        }).catch(error => console.error('GET LIST MOVIES ERROR:', error))
            .finally(() => setLoading(false));
    }

    const onCheck = (checkedItem) => {
        const newLists = moviesTableConfig.bodies.map(item => ({
            ...item,
            checked: item.id === checkedItem.id ? !item.checked : item.checked
        }));

        setMoviesConfig({
            ...moviesTableConfig,
            bodies: newLists
        });
    }

    const onCheckAll = (isCheckedAll) => {
        const newLists = moviesTableConfig.bodies.map(item => ({
            ...item,
            checked: !isCheckedAll
        }));

        setMoviesConfig({
            ...moviesTableConfig,
            bodies: newLists
        });
    }

    const onSort = (sortable) => {
        setMoviesConfig({
            ...moviesTableConfig,
            sortable
        });
    }

    const onChooseFiles = () => {
        const selected = moviesTableConfig.bodies.filter(item => item.checked);
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeApplication,
                mediaGrid: {
                    ...mediaGrid,
                    files: selected.length > 0 ? selected : moviesTableConfig.bodies
                }
            }
        }
        dispatch(changeNodeGlobalData(newNode));
        onClose();
    }

    // Sort list of movies
    useEffect(() => {
        const { field, order } = moviesTableConfig.sortable;
        const newLists = moviesTableConfig.bodies.sort((a, b) => {
            const valueA = a[field] + ''.toUpperCase();
            const valueB = b[field] + ''.toUpperCase();

            if (valueA === valueB) return 0;
            if (order === 'ASC') {
                if (valueA > valueB) return 1;
                else if (valueA < valueB) return -1;
            } else {
                if (valueA > valueB) return -1;
                else if (valueA < valueB) return 1;
            }
        });
        setMoviesConfig({
            ...moviesTableConfig,
            bodies: newLists
        });
    }, [moviesTableConfig.sortable]);

    return (
        <Dialog
            onEnter={onEnter}
            fullWidth
            maxWidth='md'
            open={open}
            onClose={onClose}
            aria-labelledby="max-width-dialog-title"
            disableEnforceFocus
        >
            <DialogTitle disableTypography id="max-width-dialog-title" style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 0 }}>
                <Box display='flex' justifyContent='flex-end' alignItems='center' marginLeft="auto">
                    <Typography className={classes.btnClose}>{translate('pos.common.close')}</Typography>
                    <CloseButton onClick={onClose}/>
                </Box>
            </DialogTitle>
            <DialogContent style={{ paddingLeft: 36, paddingRight: 36 }}>
                <Typography className={classes.Tittle}>{translate(`pos.menu.Movies`)}</Typography>
                <Table
                    config={config}
                    data={moviesTableConfig}
                    onCheck={onCheck}
                    onCheckAll={onCheckAll}
                    onSort={onSort}
                    loading={loading}
                />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <WhiteButton
                    label={translate('pos.common.cancel')}
                    onClick={onClose}
                />
                <Button
                    label={translate('pos.common.choose')}
                    onClick={onChooseFiles}
                />
            </DialogActions>
        </Dialog>
    )
}

ListMoviesDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
